module.exports = __webpack_public_path__ + "static/media/tree-step-4_2.5ce48185.svg";